import React, { useState } from "react"

const DocumentUpload = () => {
  const [attachments, setAttachments] = useState([])

  const handleAddAttachment = () => {
    setAttachments([...attachments, { name: "", file: null }])
  }

  const handleNameChange = (e, index) => {
    const newAttachments = [...attachments]
    newAttachments[index].name = e.target.value
    setAttachments(newAttachments)
    e.preventDefault()
  }

  const handleFileChange = (e, index) => {
    const newAttachments = [...attachments]
    newAttachments[index].file = e.target.files[0]
    setAttachments(newAttachments)
  }

  return (
    <div>
        <br></br>
      {attachments.map((attachment, index) => (
        <div key={index}>
          <input
          className="mt-10"
            type="text"
            placeholder="Enter document name"
            value={attachment.name}
            onChange={e => handleNameChange(e, index)}
          />
          <input className="btn" type="file" onChange={e => handleFileChange(e, index)} />
          {attachment.file && <p>Selected File: {attachment.file.name}</p>}
        </div>
      ))}
<br></br>
      <div>
        <span className="btn btn-primary" onClick={handleAddAttachment}>
          Add Attachment
        </span>
      </div>
    </div>
  )
}

export default DocumentUpload
